import GhostBar from "./GhostBar";

const GhostDataTableBody = ({ headers, rows = 10 }) => {
  return (
    <div className="standard-data-table-content">
      {/* HEADER ROW MIRROR */}
      <div className="standard-data-table-header-wrapper header-only-wrapper">
        <div className="standard-data-table-content-row">
          {headers.map((header, i) => (
            <div
              key={i}
              className={`standard-data-table-content-row-field ${
                header.className || ""
              }`}
              style={{
                flex: `0 0 ${header.width}`,
                width: header.width,
              }}
            >
              <GhostBar width="50%" height="12px" />
            </div>
          ))}
        </div>
        <div
          className="standard-table-fixed-row-right-element"
          style={{ background: "transparent", boxShadow: "none" }}
        >
          <GhostBar width="20px" height="20px" circle />
        </div>
      </div>

      {/* DATA ROWS MIRROR */}
      <div className="standard-data-table-content-row-container">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div key={rowIndex} className="standard-data-table-row-wrapper">
            <div className="standard-data-table-content-row">
              {headers.map((header, colIndex) => (
                <div
                  key={colIndex}
                  className={`standard-data-table-content-row-field ${
                    header.className || ""
                  }`}
                  style={{
                    flex: `0 0 ${header.width}`,
                    width: header.width,
                  }}
                >
                  {/* Icon + Text Ghost for Merchants */}
                  {header.key?.toLowerCase() === "merchant" ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <GhostBar
                        width="24px"
                        height="24px"
                        style={{ borderRadius: "4px" }}
                      />
                      <GhostBar width="60px" height="14px" />
                    </div>
                  ) : (
                    <GhostBar width="80%" height="14px" />
                  )}
                </div>
              ))}
            </div>

            <div className="standard-table-fixed-row-right-element">
              <GhostBar width="20px" height="20px" circle />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GhostDataTableBody;
